var map = {
	"./auto azul.svg": 2634,
	"./auto negro.svg": 1615,
	"./auto rojo.svg": 4448,
	"./auto rosa.svg": 765,
	"./avion azul.svg": 5988,
	"./avion negro.svg": 7985,
	"./avion rojo.svg": 3670,
	"./avion rosa.svg": 4095,
	"./bandera azul.svg": 5940,
	"./bandera negro.svg": 2289,
	"./bandera rojo.svg": 4246,
	"./bandera rosa.svg": 4671,
	"./bus azul.svg": 2185,
	"./bus negro.svg": 7774,
	"./bus rojo.svg": 9347,
	"./bus rosa.svg": 830,
	"./camion azul.svg": 8046,
	"./camion negro.svg": 1275,
	"./camion rojo.svg": 4436,
	"./camion rosa.svg": 8057,
	"./carrito azul.svg": 6993,
	"./carrito negro.svg": 5142,
	"./carrito rojo.svg": 8891,
	"./carrito rosa.svg": 2454,
	"./casa azul.svg": 4649,
	"./casa negro.svg": 478,
	"./casa rojo.svg": 9571,
	"./casa rosa.svg": 3582,
	"./cel azul.svg": 4531,
	"./cel negro.svg": 9208,
	"./cel rojo.svg": 9609,
	"./cel rosa.svg": 9904,
	"./copa azul.svg": 3008,
	"./copa negra.svg": 1267,
	"./copa rojo.svg": 6194,
	"./copa rosa.svg": 7424,
	"./cruce azul.svg": 6187,
	"./cruce negro.svg": 9968,
	"./cruce rojo.svg": 3121,
	"./cruce rosa.svg": 2360,
	"./escolar azul.svg": 3278,
	"./escolar negro.svg": 3563,
	"./escolar rojo.svg": 724,
	"./escolar rosa.svg": 4566,
	"./fabrica azul.svg": 5627,
	"./fabrica negro.svg": 7744,
	"./fabrica rojo.svg": 7697,
	"./fabrica rosa.svg": 9352,
	"./hospital  rojo.svg": 2763,
	"./hospital azul.svg": 8227,
	"./hospital negro.svg": 9672,
	"./hospital rosa.svg": 5040,
	"./hotel azul.svg": 145,
	"./hotel negro.svg": 2310,
	"./hotel rojo.svg": 3643,
	"./hotel rosa.svg": 1014,
	"./japones azul.svg": 3273,
	"./japones negro.svg": 3598,
	"./japones rojo.svg": 8739,
	"./japones rosa.svg": 3518,
	"./patita azul.svg": 8274,
	"./patita negro.svg": 7623,
	"./patita roja.svg": 9566,
	"./patita rosa.svg": 6501,
	"./resto azul.svg": 9948,
	"./resto negro.svg": 9689,
	"./resto rojo.svg": 4638,
	"./resto rosa.svg": 6439,
	"./semaforo azul.svg": 1551,
	"./semaforo negro.svg": 7820,
	"./semaforo rojo.svg": 5317,
	"./semaforo rosa.svg": 8196,
	"./tren azul.svg": 6184,
	"./tren negro.svg": 3661,
	"./tren rojo.svg": 8970,
	"./tren rosa.svg": 6043,
	"./tv azul.svg": 2331,
	"./tv negro.svg": 6080,
	"./tv rojo.svg": 2913,
	"./tv rosa.svg": 8504
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8546;